// CarouselLobby.jsx
import React from "react";

export default class CarouselLobby extends React.Component {
    constructor(props) {
        super(props);
        this.rootRef = React.createRef();
        this.sliderRef = React.createRef();
        this.state = {
            current: 0,
            slidesCount: 0,
        };
    }

    componentDidMount() {
        // นับจำนวน slide จริงจาก DOM
        const slidesCount = this.sliderRef.current ? this.sliderRef.current.children.length : 0;
        this.setState({ slidesCount }, () => {
            this.updateSliderTransform();
            this.updateArrowState();
        });
        // ถ้าต้องการ keyboard/resize สามารถเพิ่มได้ที่นี่
    }

    goTo = (index) => {
        const { slidesCount } = this.state;
        if (slidesCount === 0) return;
        // clamp
        const newIndex = Math.max(0, Math.min(index, slidesCount - 1));
        this.setState({ current: newIndex }, () => {
            this.updateSliderTransform();
            this.updateArrowState();
        });
    };

    prev = () => {
        this.goTo(this.state.current - 1);
    };

    next = () => {
        this.goTo(this.state.current + 1);
    };

    updateSliderTransform = () => {
        const { current } = this.state;
        if (!this.sliderRef.current) return;
        // ใช้ percent = current * 100 (แต่ original transform in your examples used -700% etc)
        // เราสมมติ slide width = 100% ต่อ item ดังนั้น translateX = -current * 100%
        const percent = -current * 100;
        this.sliderRef.current.style.transform = `translate3d(${percent}%, 0px, 0px)`;
        this.sliderRef.current.style.transitionDuration = "300ms";

        // update selected class on slides (optional, keep original classes but update .selected)
        Array.from(this.sliderRef.current.children).forEach((li, idx) => {
            if (idx === current) {
                li.classList.add("selected");
            } else {
                li.classList.remove("selected");
            }
        });
    };

    updateArrowState = () => {
        const prevBtn = this.rootRef.current?.querySelector(".control-prev");
        const nextBtn = this.rootRef.current?.querySelector(".control-next");
        const { current, slidesCount } = this.state;
        if (prevBtn) {
            if (current <= 0) prevBtn.classList.add("control-disabled");
            else prevBtn.classList.remove("control-disabled");
        }
        if (nextBtn) {
            if (current >= slidesCount - 1) nextBtn.classList.add("control-disabled");
            else nextBtn.classList.remove("control-disabled");
        }
    };

    renderDots() {
        const { slidesCount, current } = this.state;
        if (slidesCount <= 0) {
            // ถ้ายังไม่รู้จำนวน ให้แสดง 2 ดอตเดิมตามที่คุณเคยมี
            return (
                <>
                    <li>
                        <button
                            type="button"
                            aria-label="dot 1"
                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                            onClick={() => this.goTo(0)}
                        />
                    </li>
                    <li>
                        <button
                            type="button"
                            aria-label="dot 2"
                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                            onClick={() => this.goTo(1)}
                        />
                    </li>
                </>
            );
        }

        return new Array(slidesCount).fill(0).map((_, i) => (
            <li key={i}>
                <button
                    type="button"
                    aria-label={`dot ${i + 1}`}
                    aria-pressed={current === i}
                    onClick={() => this.goTo(i)}
                    style={{
                        filter: "hue-rotate(191deg) brightness(1)",
                        // เห็นในตัวอย่างคุณมีขนาดแถบเล็ก ๆ — ปรับง่าย ๆ ถ้าต้องการ
                        width: "22px",
                        height: "6px",
                        borderRadius: "1.5px",
                        background: current === i ? "#fff" : "#909090",
                        opacity: 1,
                        cursor: "pointer",
                        border: "none",
                        padding: 0,
                    }}
                />
            </li>
        ));
    }

    render() {
        return (
            <div className="carousel-root">
                <div
                    className="carousel carousel-slider"
                    id="carousel1"
                    ref={this.rootRef}
                    style={{ width: "100%" }}
                >
                    <ul className="control-dots" aria-hidden="false">
                        {this.renderDots()}
                    </ul>

                    <button
                        aria-label="previous slide / item"
                        className="control-arrow control-prev control-disabled"
                        type="button"
                        onClick={this.prev}
                    >
                        &lt;
                    </button>

                    <div className="slider-wrapper axis-horizontal">
                        <ul
                            className="slider animated"
                            ref={this.sliderRef}
                            style={{ transitionDuration: "300ms" }}
                        >

                            <li className="slide">
                                <div className="next-fill-wrapper relative mb-6 css-jh35vf">
                                    <img src="https://cdn.zabbet.com/highlight/1729060413175-40ed4eb6-ed06-417f-8618-9b58a5d48c47.gif" />
                                </div>
                                <div className="absolute flex justify-between bottom-5 left-2 right-2" style={{ marginBottom: "32px" }} >
                                    <div className="text-left">
                                        <div style={{ filter: "hue-rotate(191deg) brightness(1)" }}>
                                            <div
                                                className="absolute font-semibold text-base sm:text-lg"
                                                style={{
                                                    textShadow:
                                                        "rgb(0, 0, 0) 1px 1px 2px, rgb(0, 0, 0) 1px 1px 1px, rgb(0, 0, 0) 1px 1px 2px, rgb(0, 0, 0) 1px 1px 3px"
                                                }}
                                            >
                                                &nbsp;Pirates' Plenty
                                            </div>
                                            <div className=" relative font-semibold text-base sm:text-lg bg-clip-text text-transparent bg-gradient-to-b from-[#E1D4B4] to-[#a38f65] ">
                                                &nbsp;Pirates' Plenty
                                            </div>
                                        </div>
                                        <div
                                            className="ml-0.5 font-light opacity-70 text-[10px] sm:text-xs"
                                            style={{
                                                textShadow:
                                                    "rgb(0, 0, 0) 1px 1px 2px, rgb(0, 0, 0) 1px 1px 1px, rgb(0, 0, 0) 1px 1px 2px, rgb(0, 0, 0) 1px 1px 3px, rgb(0, 0, 0) 1px 1px 4px"
                                            }}
                                        >
                                            &nbsp;Red Tiger
                                        </div>
                                    </div>
                                    <div
                                        className=" flex items-center bg-gradient-to-b from-[#FC9532] via-[#F3702C] to-[#CB5017] rounded-md shadow-[0_0_10px_rgba(251,143,49,0.5)] cursor-pointer w-[80px] h-[32px] sm:w-[100px] sm:h-[38px] "
                                        style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                    >
                                        <div className="relative ml-2 mr-1 w-6 h-6 sm:ml-3.5 sm:mr-2"  >
                                            <span
                                                style={{
                                                    boxSizing: "border-box",
                                                    display: "block",
                                                    overflow: "hidden",
                                                    width: "initial",
                                                    height: "initial",
                                                    background: "none",
                                                    opacity: 1,
                                                    border: 0,
                                                    margin: 0,
                                                    padding: 0,
                                                    position: "absolute",
                                                    inset: 0
                                                }}
                                            >
                                                <img
                                                    src="/build/web/igame-index-lobby-wm/img/play_button.png"
                                                    decoding="async"
                                                    data-nimg="fill"
                                                    style={{
                                                        position: "absolute",
                                                        inset: 0,
                                                        boxSizing: "border-box",
                                                        padding: 0,
                                                        border: "none",
                                                        margin: "auto",
                                                        display: "block",
                                                        width: 0,
                                                        height: 0,
                                                        minWidth: "100%",
                                                        maxWidth: "100%",
                                                        minHeight: "100%",
                                                        maxHeight: "100%",
                                                        objectFit: "contain"
                                                    }}
                                                />
                                            </span>
                                        </div>
                                        <div className="font-semibold">Play</div>
                                    </div>
                                </div>

                            </li>
                            <li className="slide">
                                <div className="next-fill-wrapper relative mb-6 css-jh35vf">
                                    <img src="https://cdn.zabbet.com/highlight/1729061278062-81bf7e48-34cf-45d6-9745-0caec719c3cf.gif" />
                                </div>
                                <div className="absolute flex justify-between bottom-5 left-2 right-2" style={{ marginBottom: "32px" }} >
                                    <div className="text-left">
                                        <div style={{ filter: "hue-rotate(191deg) brightness(1)" }}>
                                            <div
                                                className="absolute font-semibold text-base sm:text-lg"
                                                style={{
                                                    textShadow:
                                                        "rgb(0, 0, 0) 1px 1px 2px, rgb(0, 0, 0) 1px 1px 1px, rgb(0, 0, 0) 1px 1px 2px, rgb(0, 0, 0) 1px 1px 3px"
                                                }}
                                            >
                                                &nbsp;Pirates' Plenty
                                            </div>
                                            <div className=" relative font-semibold text-base sm:text-lg bg-clip-text text-transparent bg-gradient-to-b from-[#E1D4B4] to-[#a38f65] ">
                                                &nbsp;Pirates' Plenty
                                            </div>
                                        </div>
                                        <div
                                            className="ml-0.5 font-light opacity-70 text-[10px] sm:text-xs"
                                            style={{
                                                textShadow:
                                                    "rgb(0, 0, 0) 1px 1px 2px, rgb(0, 0, 0) 1px 1px 1px, rgb(0, 0, 0) 1px 1px 2px, rgb(0, 0, 0) 1px 1px 3px, rgb(0, 0, 0) 1px 1px 4px"
                                            }}
                                        >
                                            &nbsp;Red Tiger
                                        </div>
                                    </div>
                                    <div
                                        className=" flex items-center bg-gradient-to-b from-[#FC9532] via-[#F3702C] to-[#CB5017] rounded-md shadow-[0_0_10px_rgba(251,143,49,0.5)] cursor-pointer w-[80px] h-[32px] sm:w-[100px] sm:h-[38px] "
                                        style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                    >
                                        <div className="relative ml-2 mr-1 w-6 h-6 sm:ml-3.5 sm:mr-2">
                                            <span
                                                style={{
                                                    boxSizing: "border-box",
                                                    display: "block",
                                                    overflow: "hidden",
                                                    width: "initial",
                                                    height: "initial",
                                                    background: "none",
                                                    opacity: 1,
                                                    border: 0,
                                                    margin: 0,
                                                    padding: 0,
                                                    position: "absolute",
                                                    inset: 0
                                                }}
                                            >
                                                <img
                                                    src="/build/web/igame-index-lobby-wm/img/play_button.png"
                                                    decoding="async"
                                                    data-nimg="fill"
                                                    style={{
                                                        position: "absolute",
                                                        inset: 0,
                                                        boxSizing: "border-box",
                                                        padding: 0,
                                                        border: "none",
                                                        margin: "auto",
                                                        display: "block",
                                                        width: 0,
                                                        height: 0,
                                                        minWidth: "100%",
                                                        maxWidth: "100%",
                                                        minHeight: "100%",
                                                        maxHeight: "100%",
                                                        objectFit: "contain"
                                                    }}
                                                />
                                            </span>
                                        </div>
                                        <div className="font-semibold">Play</div>
                                    </div>
                                </div>

                            </li>
                            <li className="slide">
                                <div className="next-fill-wrapper relative mb-6 css-jh35vf">
                                    <img src="https://cdn.zabbet.com/highlight/1729060207464-48b38a7f-6470-4e6c-9497-78803a2f7c64.gif" />
                                </div>
                                <div className="absolute flex justify-between bottom-5 left-2 right-2" style={{ marginBottom: "32px" }}>
                                    <div className="text-left">
                                        <div style={{ filter: "hue-rotate(191deg) brightness(1)" }}>
                                            <div
                                                className="absolute font-semibold text-base sm:text-lg"
                                                style={{
                                                    textShadow:
                                                        "rgb(0, 0, 0) 1px 1px 2px, rgb(0, 0, 0) 1px 1px 1px, rgb(0, 0, 0) 1px 1px 2px, rgb(0, 0, 0) 1px 1px 3px"
                                                }}
                                            >
                                                &nbsp;Pirates' Plenty
                                            </div>
                                            <div className=" relative font-semibold text-base sm:text-lg bg-clip-text text-transparent bg-gradient-to-b from-[#E1D4B4] to-[#a38f65] ">
                                                &nbsp;Pirates' Plenty
                                            </div>
                                        </div>
                                        <div
                                            className="ml-0.5 font-light opacity-70 text-[10px] sm:text-xs"
                                            style={{
                                                textShadow:
                                                    "rgb(0, 0, 0) 1px 1px 2px, rgb(0, 0, 0) 1px 1px 1px, rgb(0, 0, 0) 1px 1px 2px, rgb(0, 0, 0) 1px 1px 3px, rgb(0, 0, 0) 1px 1px 4px"
                                            }}
                                        >
                                            &nbsp;Red Tiger
                                        </div>
                                    </div>
                                    <div
                                        className=" flex items-center bg-gradient-to-b from-[#FC9532] via-[#F3702C] to-[#CB5017] rounded-md shadow-[0_0_10px_rgba(251,143,49,0.5)] cursor-pointer w-[80px] h-[32px] sm:w-[100px] sm:h-[38px] "
                                        style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                    >
                                        <div className="relative ml-2 mr-1 w-6 h-6 sm:ml-3.5 sm:mr-2">
                                            <span
                                                style={{
                                                    boxSizing: "border-box",
                                                    display: "block",
                                                    overflow: "hidden",
                                                    width: "initial",
                                                    height: "initial",
                                                    background: "none",
                                                    opacity: 1,
                                                    border: 0,
                                                    margin: 0,
                                                    padding: 0,
                                                    position: "absolute",
                                                    inset: 0
                                                }}
                                            >
                                                <img
                                                    src="/build/web/igame-index-lobby-wm/img/play_button.png"
                                                    decoding="async"
                                                    data-nimg="fill"
                                                    style={{
                                                        position: "absolute",
                                                        inset: 0,
                                                        boxSizing: "border-box",
                                                        padding: 0,
                                                        border: "none",
                                                        margin: "auto",
                                                        display: "block",
                                                        width: 0,
                                                        height: 0,
                                                        minWidth: "100%",
                                                        maxWidth: "100%",
                                                        minHeight: "100%",
                                                        maxHeight: "100%",
                                                        objectFit: "contain"
                                                    }}
                                                />
                                            </span>
                                        </div>
                                        <div className="font-semibold">Play</div>
                                    </div>
                                </div>

                            </li>
                            <li className="slide">
                                <div className="next-fill-wrapper relative mb-6 css-jh35vf">
                                    <img src="https://cdn.zabbet.com/highlight/1729060207464-48b38a7f-6470-4e6c-9497-78803a2f7c64.gif" />
                                </div>
                                <div className="absolute flex justify-between bottom-5 left-2 right-2"  style={{ marginBottom: "32px" }}>
                                    <div className="text-left">
                                        <div style={{ filter: "hue-rotate(191deg) brightness(1)" }}>
                                            <div
                                                className="absolute font-semibold text-base sm:text-lg"
                                                style={{
                                                    textShadow:
                                                        "rgb(0, 0, 0) 1px 1px 2px, rgb(0, 0, 0) 1px 1px 1px, rgb(0, 0, 0) 1px 1px 2px, rgb(0, 0, 0) 1px 1px 3px"
                                                }}
                                            >
                                                &nbsp;Pirates' Plenty
                                            </div>
                                            <div className=" relative font-semibold text-base sm:text-lg bg-clip-text text-transparent bg-gradient-to-b from-[#E1D4B4] to-[#a38f65] ">
                                                &nbsp;Pirates' Plenty
                                            </div>
                                        </div>
                                        <div
                                            className="ml-0.5 font-light opacity-70 text-[10px] sm:text-xs"
                                            style={{
                                                textShadow:
                                                    "rgb(0, 0, 0) 1px 1px 2px, rgb(0, 0, 0) 1px 1px 1px, rgb(0, 0, 0) 1px 1px 2px, rgb(0, 0, 0) 1px 1px 3px, rgb(0, 0, 0) 1px 1px 4px"
                                            }}
                                        >
                                            &nbsp;Red Tiger
                                        </div>
                                    </div>
                                    <div
                                        className=" flex items-center bg-gradient-to-b from-[#FC9532] via-[#F3702C] to-[#CB5017] rounded-md shadow-[0_0_10px_rgba(251,143,49,0.5)] cursor-pointer w-[80px] h-[32px] sm:w-[100px] sm:h-[38px] "
                                        style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                    >
                                        <div className="relative ml-2 mr-1 w-6 h-6 sm:ml-3.5 sm:mr-2">
                                            <span
                                                style={{
                                                    boxSizing: "border-box",
                                                    display: "block",
                                                    overflow: "hidden",
                                                    width: "initial",
                                                    height: "initial",
                                                    background: "none",
                                                    opacity: 1,
                                                    border: 0,
                                                    margin: 0,
                                                    padding: 0,
                                                    position: "absolute",
                                                    inset: 0
                                                }}
                                            >
                                                <img
                                                    src="/build/web/igame-index-lobby-wm/img/play_button.png"
                                                    decoding="async"
                                                    data-nimg="fill"
                                                    style={{
                                                        position: "absolute",
                                                        inset: 0,
                                                        boxSizing: "border-box",
                                                        padding: 0,
                                                        border: "none",
                                                        margin: "auto",
                                                        display: "block",
                                                        width: 0,
                                                        height: 0,
                                                        minWidth: "100%",
                                                        maxWidth: "100%",
                                                        minHeight: "100%",
                                                        maxHeight: "100%",
                                                        objectFit: "contain"
                                                    }}
                                                />
                                            </span>
                                        </div>
                                        <div className="font-semibold">Play</div>
                                    </div>
                                </div>

                            </li>
                        </ul>

                    </div>

                    <button aria-label="next slide / item" className="control-arrow control-next control-disabled" type="button" onClick={this.next}>
                        &gt;
                    </button>
                </div>
            </div>
        );
    }
}
